import React from 'react'
import { components } from 'react-select'

import Icon from '../Icon'
import MultiValueRemove from './components/MultiValueRemove'
import CategoryMenuList from './components/CascaderMenuList'

import { StyledSelect } from './styled'
import { componentStyles } from './config'
import { range } from '../../utils/locDash'

import colors from '../../constants/colors'

import { Option, SelectCascaderProps } from './Select.types'

const SelectCascaderInput: React.FC<SelectCascaderProps> = ({
  defaultValue,
	disabledLevel,
  isError = false,
  size = 'regular',
  onSelect = (value: Option<string>) => value,
  ...props
}) => {
  const onMenuOpen = () => {
    setTimeout(() => {
      const selectedOptions = document.getElementsByClassName(
        'select__cascader__option--is-focused',
      )

      for (const item of range(selectedOptions.length)) {
        selectedOptions[item].scrollIntoView({ behavior: 'auto', block: 'center' })
      }
    }, 20)
  }

  return (
    <StyledSelect
      classNamePrefix='select'
      isError={isError}
      size={size}
      isClearable={false}
      isSearchable={false}
      onBlur={props.onLeave}
      defaultValue={defaultValue}
      onMenuOpen={onMenuOpen}
      components={{
        MenuList: (props) => <CategoryMenuList {...props} onSelect={onSelect} disabledLevel={disabledLevel} />,
        MultiValueRemove,
        DropdownIndicator: (props) => (
          <components.DropdownIndicator {...props}>
            <Icon name='Down-outline' color='black50' size={20} />
          </components.DropdownIndicator>
        ),
      }}
      styles={{
        ...componentStyles,
        placeholder: (base) => ({ ...base, fontSize: '14px', color: colors.black75 }),
      }}
      {...props}
    />
  )
}

export default SelectCascaderInput
